import React from 'react';
import PropTypes from 'prop-types';

const Header = ({ className, isNewAddress, t }) => (
  <span className={className}>
    {isNewAddress ? t('new_address_title') : t('modify_address_title')}
  </span>
);

Header.propTypes = {
  t: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  isNewAddress: PropTypes.bool.isRequired,
};

export default Header;
